<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding: 0">
  <div class="page-loader" *ngIf="loadershow">
    <img
      src="assets/images/dashboard/uib-loading-500x500.gif"
      style="width: 100px"
      alt=""
    />
  </div>
  <div
    class="col-lg-8 col-md-8 col-sm-8 col-xs-8"
    style="padding-left: 0; padding-right: 0"
  >
    <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10" style="padding: 0">
      <app-page-header
        i18n-pageTitle="@@category_title"
        pageTitle="{{ 'rag.title' | translate }}"
        EngTitle="RAG"
      ></app-page-header>
    </div>
    <div
      class="col-lg-2 col-md-2 col-sm-2 col-xs-2 plusButtons actionButton ml-5"
      style="padding-left: 0; padding-right: 10px;"
    >
      <button
        class="btn-add commonButton dropdown-toggle"
        style="padding: 0"
        data-toggle="dropdown"
        id="dropdownMenuLink"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
      <ul
        class="dropdown-menu custom-dropdown"
        style="margin-top: 0; width: 130px"
      >
        <li
          class="actionMenuStyle"
          style="width: 100%"
          (click)="selectedRAGChange('document')"
          (keydown)="selectedRAGChange('document')"
        >
          Document
        </li>
        <li
          class="actionMenuStyle"
          style="width: 100%"
          (click)="selectedRAGChange('website')"
          (keydown)="selectedRAGChange('website')"
        >
          Website
        </li>
      </ul>
    </div>
  </div>

  <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8" style="padding-left: 0; padding-right: 10px;">
    <div
      class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
      style="padding: 0; text-align: right; "
    >
      <form class="search">
        <div class="search__wrapper">
          <input
            id="ragV3Search"
            [attr.aria-label]="'common.search_for' | translate"
            type="text"
            [(ngModel)]="searchRag"
            (keyup)="searchRagList($event.target['value'])"
            placeholder="{{ 'common.search_for' | translate }}"
            class="search__field"
            name="add_new_variant_question"
          />
          <button
            id="ragV3SearchSubmit"
            type="submit"
            class="fa fa-search search__icon"
            [attr.aria-label]="'common.search_for' | translate"
          ></button>
        </div>
      </form>
    </div>
  </div>
  <!-- tabs -->
  <div class="row" style="margin: 0">
    <div
      class="col-lg-8 col-md-8 col-sm-8 col-xs-8 matTabs rag-tabs"
      style="padding: 0 10px 10px 0;position: relative;margin-top: 10px;"
    >
      <div style="position: absolute; right: 5px;">
        <div style="width: 110px" *ngIf="translate_text == 'yes'">
          <ngx-select-dropdown
            class="filterStyle"
            style="text-align: start"
            tabindex="0"
            [multiple]="false"
            [config]="filterConfig1"
            [options]="languageList"
            [(ngModel)]="default_language"
            name="fieldName"
            ngDefaultControl
            (change)="languageselection(default_language?.toLowerCase())"
          >
          </ngx-select-dropdown>
        </div>
      </div>
      <mat-tab-group
        (selectedTabChange)="matTableChange($event)"
        animationDuration="0ms"
        [(selectedIndex)]="selectedIndex"
      >
        <mat-tab label="All">
          <ng-container
            *ngTemplateOutlet="fileListTpl; context: { ragfiles: allFiles }"
          >
          </ng-container>
        </mat-tab>

        <mat-tab label="Document">
          <ng-container
            *ngTemplateOutlet="fileListTpl; context: { ragfiles: allFiles }"
          >
          </ng-container>
        </mat-tab>

        <mat-tab label="Website">
          <ng-container
            *ngTemplateOutlet="fileListTpl; context: { ragfiles: allFiles }"
          >
          </ng-container>
        </mat-tab>
      </mat-tab-group>

      <ng-template #fileListTpl let-ragfiles="ragfiles">
        <ng-container *ngFor="let files of ragfiles">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 table-responsive"
            style="padding: 0"
            (click)="DetailedView(files)"
            (keydown)="DetailedView(files)"
          >
            <div style="margin-bottom: 10px; background-color: #fff">
              <div
                class="sep-ques-ans"
                [ngClass]="
                  selectedRAGTabDataID == files._id
                    ? 'highlightBorder'
                    : 'common-border'
                "
                style="cursor: pointer; max-height: none; width: 100%"
              >
                <div>
                  <div
                    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3"
                    style="
                      padding: 0;
                      color: #777777;
                      font-family: 'WorkSansLight', sans-serif;
                    "
                  >
                    <div
                      *ngIf="
                        !files.trainingStatus && files.trainingStatus !== false
                      "
                      style="
                        position: relative;
                        top: -10px;
                        display: inline-flex;
                        width: 65%;
                        word-break: normal;
                        align-items: center;
                      "
                    >
                      <span>{{
                        !files.trainingStatus && files.trainingStatus !== false
                          ? 'Training'
                          : ''
                      }}</span>
                      <mat-progress-bar
                        class="example-margin"
                        [color]="color"
                        [mode]="mode"
                        [value]="value"
                        [bufferValue]="bufferValue"
                      >
                      </mat-progress-bar>
                    </div>
                    <div
                      class="row d-flex align-items-center"
                      style="margin: auto"
                    >
                      <!-- 1 -->

                      <div
                        class="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                        title="{{ 
                          files.modified_on | date: dateFormat }} {{ files.modified_on | date: 'h:mm a' 
                        }}"
                        style="
                          padding-left: 0;
                          text-align: start;
                          white-space: normal;
                          word-break: keep-all;
                        "
                      >
                        {{ files.modified_on | date: dateFormat }}&nbsp;{{ files.modified_on | date: 'h:mm a' }}
                      </div>
                      <!-- 2 -->
                      <div
                        class="col-lg-8 col-md-8 col-sm-8 col-xs-8 d-flex align-items-center"
                        style="
                          padding-right: 0;
                          justify-content: end;
                          display: inline-flex;
                        "
                      >
                        <em
                          *ngIf="files.trainingStatus"
                          style="
                            color: green;
                            text-shadow: 0 0 3px green;
                            margin-right: 5px;
                          "
                          title="Approved"
                          class="fas fa-circle"
                        >
                        </em>

                        <em
                          *ngIf="files.trainingStatus === false"
                          style="color: red; text-shadow: 0 0 3px red"
                          title="Rejected"
                          class="fas fa-circle"
                        >
                        </em>
                        <div style="cursor: pointer" *ngIf="
                        files.trainingStatus ||  files.trainingStatus === false
                      ">
                          <div ngbDropdown class="d-inline-block">
                            <a
                              style="padding: 0 5px 0 10px; color: #777777"
                              ngbDropdownToggle
                            >
                              <em class="fa fa-ellipsis-v"></em>
                            </a>
                            <ul
                              class="dropdown-menu-question"
                              ngbDropdownMenu
                              aria-labelledby="dropdownBasic1"
                            >
                              <li></li>
                              <li>
                                <a
                                  (click)="
                                    openConfirmationDialog(files._id, files)
                                  "
                                  (keydown)="
                                    openConfirmationDialog(files._id, files)
                                  "
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 3 -->
                    <div
                      class="col-lg-10 col-md-12 col-sm-12 col-xs-12"
                      style="
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <!-- Left Content Box -->
                      <div
                        class="col-lg-10 col-md-10 col-sm-10 col-xs-10 mainPlus"
                        title="{{ files.filename }}"
                        (keydown)="RediredctToNewTab(files.s3url)"
                        (click)="RediredctToNewTab(files.s3url)"
                        style="
                          padding: 10px;
                          word-break: break-word;
                          border-radius: 10px;
                          box-shadow: 1px 3px 6px 1px #cccccc;
                          margin-top: 10px;
                          display: flex;
                          align-items: center;
                          text-align: start;
                        "
                      >
                        <img
                          *ngIf="
                            files.type == 'website' || files.type == 'document'
                          "
                          [src]="
                            files.type == 'website'
                              ? 'assets/images/website.png'
                              : files.type == 'document'
                                ? 'assets/images/pdf_document.png'
                                : ''
                          "
                          style="width: 20px; margin-right: 10px"
                          alt=""
                        />
                        <span class="truncate-filename">{{
                          files.filename
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="allFiles?.length > 0">
          <app-pagination
            [collectionSize]="totalCount"
            [(page)]="page"
            [maxSize]="3"
            [disabled]="paginationDisabled"
            (pageChange)="pageChanged($event)"
          ></app-pagination>
        </div>
        <!-- empty state -->
        <div *ngIf="ragfiles && ragfiles.length === 0" class="no-msg">
          {{ 'common.no_records_found' | translate }}
        </div>
      </ng-template>
    </div>
    <div
      class="col-lg-4 col-md-4 col-sm-4 col-xs-4 rightBar"
      *ngIf="selectedRAGTab || selectedRAGTabData"
    >
      <div *ngIf="selectedRAGTabDataID !== null">
        <div class="">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
            style="display: inline-flex"
          >
            <h4
              class="col-lg-9 col-md-9 col-sm-9 col-xs-9 viewHeading"
              style="
                display: block;
                margin: auto;
                margin-top: 1px;
                word-break: keep-all;
                white-space: normal;
              "
            >
              Detailed Information
            </h4>
            <div
              class="col-lg-3 col-md-3 col-sm-3 col-xs-3 actionButton"
              style="float: right; padding: 0; top: 20px; margin-right: 10px" *ngIf="selectedRAGTabData.trainingStatus || selectedRAGTabData.trainingStatus === false"
            >
              <button
                class="customButtonStyle commonButton dropdown-toggle lang-dropdown"
                style="
                  width: 100%;
                  height: 30px;
                  text-align: center;
                  padding: 6px;
                  display: inline-flex;
                  font-size: 12px;
                  font-family: 'WorkSansMedium', sans-serif;
                  white-space: nowrap;
                  min-width: 94px;
                "
                type="button"
                data-toggle="dropdown"
              >
                Actions &nbsp;&nbsp;<em
                  class="fas fa-chevron-down"
                  style="margin-top: 4%"
                ></em>
              </button>
              <ul class="dropdown-menu custom-dropdown-adjustment">
                <li
                  class="actionMenuStyle"
                  (keydown)="
                    openConfirmationDialog(
                      selectedRAGTabData?._id,
                      selectedRAGTabData
                    )
                  "
                  (click)="
                    openConfirmationDialog(
                      selectedRAGTabData._id,
                      selectedRAGTabData
                    )
                  "
                >
                  Delete
                </li>
              </ul>
            </div>
          </div>
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
            style="padding-left: 6%"
          >
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
              style="padding: 5% 0; font-family: 'WorkSansLight', sans-serif"
            >
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                style="padding: 0"
              >
                <p class="question-view-label" i18n="@@status">Status</p>
                <p class="view-answer-part" style="text-transform: capitalize">
                  {{
                    !selectedRAGTabData.trainingStatus &&
                    selectedRAGTabData.trainingStatus !== false
                      ? 'Pending'
                      : selectedRAGTabData.trainingStatus === false
                        ? 'Rejected'
                        : 'Approved'
                  }}
                </p>
              </div>
              <br />
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                style="padding: 0"
              >
                <p
                  class="question-view-label"
                  style="font-family: 'WorkSansLight', sans-serif"
                >
                  {{
                    selectedRAGTabData.type == 'website' ? 'URL' : 'File Name'
                  }}
                </p>
                <a
                  (click)="RediredctToNewTab(selectedRAGTabData.s3url)"
                  class="view-questions-part"
                  style="
                    font-family: 'WorkSansLight', sans-serif;
                    cursor: pointer;
                  "
                >
                  {{ selectedRAGTabData.filename }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Document------------ -->
      <form *ngIf="selectedRAGTab == 'document'">
        <div class="form-body">
          <div>
            <h3 i18n="@@question_reject">Add Document</h3>
            <p class="question-form-label" i18n="@@comment">
              <label for="ragV3DocumentFile">Upload Document</label>
            </p>

            <div style="height: 200px; width: 280px">
              <input
                id="ragV3DocumentFile"
                hidden
                type="file"
                accept=".pdf"
                class="form-control ustom-file-input"
                [disabled]="uploadLoader || deleteFlag || istraining"
                (change)="handleFileUpload($event)"
                style="height: 40px; border: none"
                #fileInput
                title="Choose a PDF File"
              />
              <img
                *ngIf="uploadLoader"
                alt=""
                src="assets/images/dashboard/uib-loading-500x500.gif"
                style="width: 8%; position: relative; left: 288px; bottom: 31px"
              />
              <em
                [popover]="popUpRag"
                [placement]="'right'"
                [container]="'body'"
                [outsideClick]="true"
                class="fas fa-info-circle"
                triggers="mouseenter mouseleave click"
                style="
                  position: relative;
                  top: -30px;
                  left: 293px;
                  display: inline-block;
                "
              ></em>

              <div
                style="
                  display: inline-flex;
                  justify-content: flex-end;
                  width: 100%;
                  gap: 10px;
                  margin-top: 20px;
                "
              >
                <button
                  type="button"
                  (click)="uploadFile()"
                  [disabled]="!uploadedFile || uploadLoader"
                  id="questinRejectedQueBtnLs"
                  class="commonButton btn-blue"
                  i18n="@@rejectedBtn"
                >
                  Update
                </button>
                <button
                  type="button"
                  (click)="CancelDocumentUpload()"
                  id="questinCancelQueBtnLs"
                  class="btn-grey"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- website------------ -->
      <form *ngIf="selectedRAGTab == 'website'">
        <div class="" style="padding: 15px 20px">
          <div>
            <h3 i18n="@@question_reject">Add Website</h3>
            <p class="question-form-label" i18n="@@comment">
              <label for="ragV3WebsiteUrl">Enter URL</label>
            </p>
            <div>
              <div>
                <div>
                  <div style="display: flex">
                    <input
                      id="ragV3WebsiteUrl"
                      [disabled]="uploadUrlLoader || deleteFlag || istraining"
                      class="form-control"
                      (keyup)="onKey($event)"
                      type="text"
                      [(ngModel)]="urlName"
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 100%; flex: 0 0 auto"
                    />
                    <span
                      *ngIf="uploadUrlLoader"
                      style="position: relative; left: -22px; bottom: -8px"
                    >
                      <img
                        alt=""
                        src="assets/images/dashboard/uib-loading-500x500.gif"
                        style="width: 18px"
                      />
                    </span>
                  </div>

                  <div style="text-align: center">
                    <button
                      class="btn-save commonButton"
                      [disabled]="uploadUrlLoader"
                      style="height: 35px; width: 143px; margin-top: 5px"
                      (click)="train()"
                    >
                      {{ 'setting.addAndTrain' | translate }}
                    </button>
                    <button
                      (click)="cancelWebsiteUpload()"
                      id="btnLs"
                      class="btn-grey"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ng-template #popUpRag>
  <div class="card" style="border: none; max-height: 250px">
    <div class="card-body" style="padding: 0 0 5px 0 !important; height: 15%">
      <p
        class="card-text"
        style="font-size: 12px"
        innerHtml="{{ 'setting.rag_info' | translate }}"
      ></p>
    </div>
  </div>
</ng-template>
